import { createContext } from 'react';

import type { SseRuntimeStore } from './types/sse-runtime-store.type';

/**
 * React context for managing Server-Sent Events (SSE) state and functionality.
 *
 * Provides access to SSE-related data and methods throughout the component tree.
 * The context value conforms to the `SseRuntimeStore` type, or is `undefined` if not provided.
 *
 * @see SseRuntimeStore
 */
export const SseContext = createContext<SseRuntimeStore | undefined>(undefined);
